import { ElementDefinition, LayoutOptions, Stylesheet } from "cytoscape";
import { useMemo } from "react";

import { RelatedCasesDisplayElementConfig } from "src/dynamic-view-renderer/Widgets/RelatedCases/relatedCases.typings.ts";
import { WidgetProperty } from "src/dynamic-view-renderer/Widgets/Widget.typings.ts";
import { useTheme } from "src/theme";
import { Case } from "src/types/case";
import { PageInfo } from "src/types/common";

import useColaMapping from "../Graph/colaLayout/cola.mapping";
import colaOptions from "../Graph/colaLayout/cola.options";
import { colaStyles } from "../Graph/colaLayout/cola.styles";

export type IdentifiedCasesGraphResult = {
  graphData: ElementDefinition[];
  graphLayout: LayoutOptions;
  graphStyles: Stylesheet[];
};

export const useGetIdentifiedCasesGraphData = (
  casesPage: {
    cases: Case[];
    pageInfo: PageInfo;
  } | null,
  configuration: RelatedCasesDisplayElementConfig[],
  identifier: WidgetProperty
): IdentifiedCasesGraphResult => {
  const { colors } = useTheme();
  const cases = casesPage?.cases ?? [];
  const [firstCase, ...relatedCases] = cases;

  const graphData = useColaMapping({
    elementsConfig: configuration,
    caseInfo: firstCase
      ? {
          caseId: firstCase.id,
          alertId: firstCase.id,
          propertyValues: firstCase.properties,
          elements: firstCase.elements,
        }
      : { alertId: "", propertyValues: [], elements: [] },
    relatedCases,
    options: {
      filteredIdentifiers: identifier.id ? [identifier.id] : [],
    },
  });

  const { graphLayout, graphStyles } = useMemo(
    () => ({
      graphLayout: colaOptions,
      graphStyles: colaStyles(colors) as Stylesheet[],
    }),
    [colors]
  );

  return {
    graphData: cases.length === 0 ? [] : graphData,
    graphLayout,
    graphStyles,
  };
};
